const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;

let headers = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
};

// API to check validity of domains uploaded via file
const checkBulkDomainListAPI = async (
  accessToken: string, // access token
  domainListFile: File // file
): Promise<any> => {
  const url = `${baseURL}/import-domains`;

  const formData = new FormData();

  formData.append("import_file", domainListFile);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

// API to update bulk domains
const bulkDomainListActionAPI = async (
  accessToken: string, // access token
  objId: number, // domain Id
  domain: string, // domain name
  planId: number, // plan id
  action: string // action
): Promise<any> => {
  const url = `${baseURL}/partner-update-domains`;

  const formData = new FormData();

  formData.append("id", objId.toString());
  formData.append("domain", domain);
  formData.append("plan_id", planId.toString());
  formData.append("action", action);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

export { checkBulkDomainListAPI, bulkDomainListActionAPI };

// API to Add Domain on account
const AddDomainOnAccount = async (token: string): Promise<any> => {
  // alldetail=true will fetch all details about the domain
  const url = `${baseURL}/add-domains-on-account`;
  try {
    // fetch API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + token,
      },
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

export { AddDomainOnAccount };

const AddDomainSelectedIds = async (
  selectedDomainIds?: any,
  accessToken?: string // access token
): Promise<any> => {
  // alldetail=true will fetch all details about the domain
    
  const formData = new FormData();
  selectedDomainIds.forEach((id:any) => {
    formData.append("selectedDomainIds[]", id.toString());
  });
  const url = `${baseURL}/add-domains-on-account`
  try {
    // fetch API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

export { AddDomainSelectedIds };
